module.exports = __webpack_public_path__ + "img/b9.16fe11cd.png";